export const DEFAULT_COMPETITION_RETURN = "/matches";

const COMPETITION_PATH_PREFIXES = [
  "/competition",
  "/matches",
  "/tournaments",
  "/leaderboards"
];

const AUTH_PATH_PREFIXES = [
  "/auth/sign-in",
  "/auth/sign-up",
  "/auth/forgot-password"
];

function pathOnly(value) {
  return String(value || "").split(/[?#]/)[0] || "/";
}

export function isCompetitionReturnTo(value) {
  const pathname = pathOnly(value);
  return COMPETITION_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function normalizeReturnTo(value, fallback = DEFAULT_COMPETITION_RETURN) {
  const candidate = String(value || "").trim();
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//") || /[\r\n]/.test(candidate)) {
    return fallback;
  }

  const pathname = pathOnly(candidate);
  if (AUTH_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return fallback;
  }

  return candidate;
}

export function buildCurrentReturnTo(location, fallback = DEFAULT_COMPETITION_RETURN) {
  if (!location) {
    return fallback;
  }
  return normalizeReturnTo(
    `${location.pathname || ""}${location.search || ""}${location.hash || ""}`,
    fallback
  );
}

export function getReturnToFromLocation(location, fallback = DEFAULT_COMPETITION_RETURN) {
  const params = new URLSearchParams(location?.search || "");
  return normalizeReturnTo(params.get("returnTo"), fallback);
}

export function buildAuthReturnPath(authPath, returnTo, fallback = DEFAULT_COMPETITION_RETURN) {
  const target = normalizeReturnTo(returnTo, fallback);
  const params = new URLSearchParams({ returnTo: target });
  return `${authPath}?${params.toString()}`;
}
